import React, { useState, useEffect } from 'react';
import { message, Upload } from 'antd';
import axios from 'axios';
import Lottie from 'react-lottie';
import animationData from '@/lottie/loading.json';
import { getProductLogoUploadUrl } from '@/api/createCampaignApi';

interface Props {
  onChange: Function;
  children: React.ReactNode;
  type?: 'single' | 'multiple';
  value?: any[];  // 已有的图片列表，用于编辑场景
}

const UploadImages: React.FC<Props> = ({ onChange, children, type = "single", value }) => {
  const [fileList, setFileList] = useState<any[]>(value || []);
  const [file, setFile] = useState(null);

  // 同步外部传入的 value 到内部 state
  useEffect(() => {
    if (value !== undefined) {
      setFileList(value);
    }
  }, [value]);
  const [loading, setLoading] = useState(false);
  const getAwsUrlAndUpload = async (file: any) => {
    setLoading(true);
    try {
      // 大小大于10MB
      if (file.size > 10 * 1024 * 1024) {
        message.error('The file size cannot exceed 10MB!');
        return Promise.reject(new Error('The file size cannot exceed 10MB!'));
      }
      const res = await getProductLogoUploadUrl({ key: file.name });
      const presignedUrl = res?.data?.presignedUrl;
      const publicUrl = res?.data?.publicUrl;
      const options = {
        headers: {
          'Content-Type': file.type
        }
      };
      await axios.put(presignedUrl, file, options);
      const result: any = type === 'single' ? { src: publicUrl, fileName: file.name } : [...fileList, { src: publicUrl, fileName: file.name }];
      console.log('result ===>', result, type, publicUrl, fileList);
      if (type === 'single') {
        setFile(result);
      } else {
        setFileList(result);
      }
      onChange(result);

      setTimeout(() => {
        return Promise.resolve(presignedUrl);
      }, 0);
    } catch (error: any) {
      message.error(error?.message || 'Failed to upload image');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className='w-[20px] h-[20px]'>
        <Lottie options={{
          loop: true,
          autoplay: true,
          animationData,
          rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',  // 渲染设置，保持动画的纵横比
          }
        }}
          width={20}
          height={20}
        />
      </div>
    )
  }

  return (
    <Upload
      listType="picture"
      accept=".svg,.png,.webp,.jpeg,.jpg"
      showUploadList={false}
      className="avatar-uploader"
      beforeUpload={getAwsUrlAndUpload}
      disabled={loading}
    >
      {children}
    </Upload>
  );
}

export default UploadImages;
